import React, { useEffect, useState } from 'react';

const STEPS = [
  { label: 'Generating your HIPAA certificate PDF…' },
  { label: 'Uploading certificate to secure storage…' },
  { label: 'Logging completion to admin dashboard…' },
  { label: 'Sending certificate to your email…' },
  { label: 'Finalizing your record…' },
];

export default function LoadingScreen() {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const timers = STEPS.map((_, i) =>
      setTimeout(() => setActiveStep(i + 1), i * 1800 + 800)
    );
    return () => timers.forEach(clearTimeout);
  }, []);

  return (
    <div className="card" style={{ textAlign: 'center' }}>
      <div className="loading-screen">
        <div
          style={{
            width: 64, height: 64,
            background: 'linear-gradient(135deg, #1B3A5C, #00A3A3)',
            borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 30, marginBottom: 24,
            boxShadow: '0 8px 24px rgba(0,163,163,0.3)',
          }}
        >
          🦷
        </div>

        <div className="spinner" />

        <div className="loading-title">Processing Your Training Completion</div>
        <p style={{ fontSize: 13, color: '#546E7A', marginTop: 6, marginBottom: 24 }}>
          Krona Dentistry / Odyssey Solutions is generating your certificate.<br />
          Please do not close or refresh this page.
        </p>

        <ul className="loading-steps">
          {STEPS.map((step, i) => {
            const status =
              i < activeStep ? 'done' : i === activeStep ? 'active' : 'pending';
            return (
              <li key={i} className={`loading-step ${status}`}>
                <span className={`loading-step-icon ${status}`}>
                  {status === 'done' ? '✓' : status === 'active' ? '…' : '○'}
                </span>
                {step.label}
              </li>
            );
          })}
        </ul>

        <p style={{ fontSize: 11, color: '#90A4AE', marginTop: 32 }}>
          © Krona Dentistry / Odyssey Solutions — HIPAA Compliance Training Portal
        </p>
      </div>
    </div>
  );
}
